const MostPopularHotelData = [
    {
      id: 1,
      image: "https://tranquil-licorice-79e76f.netlify.app/images/popular3.jpg",
      country: "Italy",
      name: "Hotel Valle",
      price: "$300.00",
    },
    {
      id: 2,
      image: "https://tranquil-licorice-79e76f.netlify.app/images/popular1.jpg",
      country: "Mexico",
      name: "Hotel Las Trojes",
      price: "$400.00",
    },
    {
      id: 3,
      image: "https://tranquil-licorice-79e76f.netlify.app/images/popular2.jpg",
      country: "United States",
      name: "Rosen Shingle Creek",
      price: "$500.00",
    },
    {
      id: 4,
      image: "https://tranquil-licorice-79e76f.netlify.app/images/popular4.jpg",
      country: "Thailand",
      name: "Ansan Hotel",
      price: "$100.00",
    },
    {
      id: 5,
      image: "https://tranquil-licorice-79e76f.netlify.app/images/popular5.jpg",
      country: "Vietnam",
      name: "Fawlty Tower",
      price: "$200.00",
    },
    {
      id: 6,
      image: "https://tranquil-licorice-79e76f.netlify.app/images/popular1.jpg",
      country: "Mexico",
      name: "Hotel Las Trojes",
      price: "$400.00",
    },
    {
      id: 7,
      image: "https://tranquil-licorice-79e76f.netlify.app/images/popular2.jpg",
      country: "United States",
      name: "Rosen Shingle Creek",
      price: "$500.00",
    },
    {
      id: 8,
      image: "https://tranquil-licorice-79e76f.netlify.app/images/popular4.jpg",
      country: "Thailand",
      name: "Ansan Hotel",
      price: "$100.00",
    },
  ]
  
  export default MostPopularHotelData;